import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AuthHeaderTextComponent from '../../../components/common/auth/AuthHeaderTextComponent';
import AuthPasswordHandle from '../../../components/common/auth/AuthPasswordHandle';
import AuthRootComponent from '../../../components/common/auth/AuthRootComponent';
import { useSelector } from 'react-redux';
import i18n from '../../../utils/i18n';
const SetNewPassword = () => {
  const { t } = useTranslation(['auth', 'common']);
  const language = useSelector((state) => state.languageReducer.language);

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);
  return (
    <>
      <AuthRootComponent>
        <div className="w-full md:w-96 bg-white dark:bg-slate-800 dark:text-slate-200 px-6 py-10 rounded-md m-6">
          <AuthHeaderTextComponent
            title={t('common:set_password')}
            desc={t('auth:create_new_password')}
          />
          <AuthPasswordHandle slug={'passwordSet'} />
        </div>
      </AuthRootComponent>
    </>
  );
};

export default SetNewPassword;
